import { useFormikContext } from 'formik';
import styled from 'styled-components';

import { withAPIService } from '../../../../networking';
import { withStore } from '../../../../store';
import { updateField } from '../../../../store/customer';
import type { CardApiService, CardDispatch, CardStore } from '../../types';

const CopyTextWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-self: flex-end;
`;

const Copy = styled.span`
  color: #1589ee;
  cursor: pointer;
`;

interface CopyShipToProps {
  index: number;
  category: string;
  dispatch: CardDispatch;
  store: CardStore;
  apiService: CardApiService;
}

function CopyShipTo({ index, category, dispatch, store, apiService }: CopyShipToProps) {
  const { setFieldValue } = useFormikContext();

  function copyShipToDetails(copyFromShipToNumber: number, objectToCopy: string, copyToShipToNumber: number) {
    const shipToToCopy = store.customer.shipTo[copyFromShipToNumber][objectToCopy];
    Object.keys(shipToToCopy).forEach(key => {
      setFieldValue(`shipTo[${copyToShipToNumber}].${objectToCopy}.${key}`, shipToToCopy[key]);
    });
    dispatch(
      updateField({
        name: `shipTo[${copyToShipToNumber}].${objectToCopy}`,
        value: shipToToCopy
      })
    );
    apiService.updateCustomer(store.customer, dispatch);
  }

  const emptyArr = Array.from(Array(index));

  return (
    <CopyTextWrapper>
      {emptyArr.map((_, i) => (
        <Copy key={i} onClick={() => copyShipToDetails(i, category, index)}>
          Use Details From Ship To {i + 1}
        </Copy>
      ))}
    </CopyTextWrapper>
  );
}

export default withAPIService(withStore(CopyShipTo));
